import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./Inventario.css";
import { toast } from "react-toastify";
import {
  FiActivity,
  FiDownload,
  FiUpload,
  FiSearch,
  FiEdit2,
  FiTrash2,
  FiBox,
  FiPlusCircle,
  FiDollarSign,
} from "react-icons/fi";
import PageTitle from "../components/PageTitle";

const API = process.env.REACT_APP_API_INVENTARIO; // base


function Inventario() {
  const [items, setItems] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({
    search: "",
    category: "",
    type: "",
    location: "",
    shelf: "",
    proveedor: "",
  });
  const [page, setPage] = useState(1);
  const [limit] = useState(20);

  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    code: "",
    name: "",
    category: "",
    type: "Fisico",
    supplier: "",
    warehouse: "",
    shelf: "",
    initialQty: 0,
    currentQty: 0,
    costPrice: 0,
    salePrice: 0,
    receivedAt: "",
    notes: "",
  });

  const [showMovements, setShowMovements] = useState(false);
  const [activeItem,] = useState(null);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [confirmWooOpen, setConfirmWooOpen] = useState(false);

  const [wooLoading, setWooLoading] = useState(false);
  const [wooResult, setWooResult] = useState(null);

  const [saving, setSaving] = useState(false);

  const [entradaObservacion, setEntradaObservacion] = useState("");
  const [guardandoEntrada, setGuardandoEntrada] = useState(false);

  // === Cargar datos (con filtros) ===
  const load = async () => {
    const token = localStorage.getItem("token");

    const params = {
      page,
      limit,
      search: filters.search || undefined,
      category: filters.category || undefined,
      type: filters.type || undefined,
      location: filters.location || undefined,
      shelf: filters.shelf || undefined,
      proveedor: filters.proveedor || undefined,
    };

    // Página actual
    const res = await axios.get(
      `${API}/items`,
      {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setItems(res.data.data);
    setTotal(res.data.total);

    // TODOS los productos
    const fullRes = await axios.get(
      `${API}/items`,
      {
        params: { limit: 999999 },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setAllItems(
      fullRes.data.data.sort((a, b) =>
        a.name.localeCompare(b.name, "es", {
          sensitivity: "base",
        })
      )
    );
  };

  useEffect(() => {
    load();
  }, [filters, page]); // eslint-disable-line

  const openCreate = () => {
    setEditing(null);
    setForm({
      code: "",
      name: "",
      category: "",
      type: "Fisico",
      supplier: "",
      warehouse: "",
      shelf: "",
      initialQty: 0,
      currentQty: 0,
      costPrice: 0,
      salePrice: 0,
      receivedAt: new Date().toISOString().slice(0, 10),
      notes: "",
    });
    setShowForm(true);
  };

  const openEdit = (it) => {
    setEditing(it._id);
    setForm({
      code: it.code || "",
      name: it.name || "",
      category: it.category || "",
      type: it.type || "Fisico",
      supplier: it.proveedor || "",
      warehouse: it.location || "",
      shelf: it.shelf || "",
      initialQty: it.initialQty || 0,
      currentQty: it.quantity || 0,
      costPrice: it.costPrice || 0,
      salePrice: it.salePrice || 0,
      receivedAt: it.fechaIngreso
        ? new Date(it.fechaIngreso).toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10),
      notes: it.observaciones || "",
    });
    setShowForm(true);
  };

  const saveItem = async (e) => {
    e.preventDefault();

    if (saving) return;
    setSaving(true);

    const dataToSend = {
      code: form.code,
      name: form.name,
      category: form.category,
      type: form.type,
      proveedor: form.supplier,
      location: form.warehouse,
      shelf: form.shelf,
      initialQty: Number(form.initialQty) || 0,
      quantity: Number(form.currentQty) || 0,
      costPrice: Number(form.costPrice) || 0,
      salePrice: Number(form.salePrice) || 0,
      fechaIngreso: form.receivedAt || new Date().toISOString(),
      observaciones: form.notes,
    };

    try {
      if (editing) {
        await axios.put(`${API}/items/${editing}`, dataToSend);
      } else {
        await axios.post(`${API}/items`, dataToSend);
      }
      setShowForm(false);
      load();
    } catch (err) {
      console.error("❌ Error al guardar:", err);
      alert("Error al guardar el producto. Revisa la consola.");
    } finally {
      setSaving(false);
    }
  };

  const delItem = (id) => {
    setItemToDelete(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${API}/items/${itemToDelete}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setConfirmOpen(false);
      setItemToDelete(null);
      load();
    } catch (err) {
      console.error("❌ Error al eliminar:", err);
      alert("Error al eliminar el producto");
    }
  };

  const handleExportExcel = async () => {
    try {
      // 🔹 Pasar filtros activos al backend
      const params = new URLSearchParams({
        search: filters.search || "",
        category: filters.category || "",
        type: filters.type || "",
        location: filters.location || "",
        shelf: filters.shelf || "",
        page,
        limit,
      });

      // 🔹 Solicitud al backend con filtros aplicados
      const response = await axios.get(`${API}/items/export.xlsx?${params.toString()}`, {
        responseType: "blob", // importante para archivos binarios
      });

      // 🔹 Crear descarga manual
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `inventario_filtrado_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("❌ Error al exportar Excel:", error);
      alert("No se pudo generar el archivo. Revisa la consola.");
    }
  };

  let usuario = null;

  try {
    usuario = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    usuario = null;
  }

  const usuarioNombre =
    usuario?.nombre ||
    usuario?.name ||
    usuario?.email ||
    "Sistema";

  const pages = useMemo(() => Math.ceil(total / limit), [total, limit]);

  const uniqueCategories = [...new Set(allItems.map((i) => i.category).filter(Boolean))];
  const uniqueTypes = [...new Set(allItems.map((i) => i.type).filter(Boolean))];
  const uniqueLocations = [...new Set(allItems.map((i) => i.location).filter(Boolean))];
  const uniqueShelves = [...new Set(allItems.map((i) => i.shelf).filter(Boolean))];

  const uniqueProviders = [
    ...new Set(allItems.map((i) => i.proveedor).filter(Boolean))
  ];

  // === 🔍 FILTRO GENERAL (corrige: search y categoria vienen de filters) ===
  const filteredItems = useMemo(() => {
    if (!Array.isArray(items)) return [];

    return items.filter((it) => {
      const q = (filters.search || "").toLowerCase().trim();

      const matchSearch =
        it.name?.toLowerCase().includes(q) ||
        it.code?.toLowerCase().includes(q) ||
        it.category?.toLowerCase().includes(q) ||
        it.proveedor?.toLowerCase().includes(q);

      const matchCategory = filters.category ? it.category === filters.category : true;
      const matchType = filters.type ? it.type === filters.type : true;
      const matchLocation = filters.location ? it.location === filters.location : true;
      const matchShelf = filters.shelf ? it.shelf === filters.shelf : true;
      const matchProveedor = filters.proveedor ? it.proveedor === filters.proveedor : true;

      return matchSearch && matchCategory && matchType && matchLocation && matchShelf && matchProveedor;
    });
  }, [items, filters]);

  // === 📊 RESUMEN SUPERIOR ===

  // 🔥 Detectar si hay filtros activos
  const hasFilters = useMemo(() => {
    return (
      filters.search ||
      filters.category ||
      filters.type ||
      filters.location ||
      filters.shelf
    );
  }, [filters]);

  // 🔥 Lista que usará el resumen
  // - Si NO hay filtros → usa todos los productos
  // - Si hay filtros → usa los filtrados
  const summaryItems = useMemo(() => {

    const source = hasFilters
      ? filteredItems
      : allItems;

    // ❌ Excluir servicios de KPI
    return source.filter(
      (it) =>
        (it.type || "").toLowerCase() !== "servicio"
    );

  }, [hasFilters, filteredItems, allItems]);

  // 🔹 Total coste
  const totalCost = useMemo(
    () =>
      summaryItems.reduce(
        (acc, it) =>
          acc + (Number(it.costPrice) || 0) * (Number(it.quantity) || 0),
        0
      ),
    [summaryItems]
  );

  // 🔹 Total venta
  const totalSale = useMemo(
    () =>
      summaryItems.reduce(
        (acc, it) =>
          acc + (Number(it.salePrice) || 0) * (Number(it.quantity) || 0),
        0
      ),
    [summaryItems]
  );

  // 🔹 Total unidades
  const totalProducts = useMemo(
    () =>
      summaryItems.reduce((acc, it) => acc + Number(it.quantity || 0), 0),
    [summaryItems]
  );

  // 🎨 Gama de colores
  const categoryColors = [
    "#8354DA",
    "#9062DC",
    "#9D70DE",
    "#AA7EE0",
    "#B78CE3",
    "#C59BE6",
    "#D2ADF0",
    "#DDC6F4",
    "#E6E0F8",
  ];

  // 📦 Distribución por categoría
  const categoryStats = useMemo(() => {
    const total = summaryItems.reduce(
      (acc, it) => acc + (it.quantity || 0),
      0
    );

    const grouped = summaryItems.reduce((acc, it) => {
      const cat = it.category || "Sin categoría";
      acc[cat] = (acc[cat] || 0) + (it.quantity || 0);
      return acc;
    }, {});

    const sorted = Object.entries(grouped)
      .map(([name, count]) => ({
        name,
        count,
      }))
      .sort((a, b) => b.count - a.count);

    return sorted.map((cat, idx) => ({
      ...cat,
      percent: total ? (cat.count / total) * 100 : 0,
      color:
        categoryColors[
        Math.min(idx, categoryColors.length - 1)
        ],
    }));
  }, [summaryItems]);

  // arriba del componente
  const [showMovModal, setShowMovModal] = useState(false);
  const [movItem, setMovItem] = useState(null);
  const [movimientos, setMovimientos] = useState([]);

  const verMovimientos = async (item) => {
    try {
      const res = await axios.get(
        `${API}/items/${item._id}/movimientos`
      );
      setMovimientos(res.data || []);
      setMovItem(item);
      setShowMovModal(true);
    } catch (err) {
      console.error("❌ Error cargando movimientos:", err);
      // si ya usas toast:
      // toast.error("No se pudieron cargar los movimientos.");
      toast.error("No se pudieron cargar los movimientos.");
    }
  };

  const getTipoMovimientoLabel = (mov) => {
    const note = (mov.note || "").toLowerCase();

    if (mov.kind === "entrada") {
      // Si en la nota dice devolución, lo mostramos distinto
      if (note.includes("devolución") || note.includes("devolucion")) {
        return "Entrada por devolución";
      }
      return "Entrada";
    }

    if (mov.kind === "salida") return "Salida";
    if (mov.kind === "ajuste") return "Ajuste";
    if (mov.kind === "cambio") return "Cambio de datos";

    return mov.kind;
  };

  // === ENTRADA MANUAL ===
  const [showEntradaManual, setShowEntradaManual] = useState(false);
  const [entradaManualItem, setEntradaManualItem] = useState(null);
  const [entradaCantidad, setEntradaCantidad] = useState(0);
  const [entradaMotivo, setEntradaMotivo] = useState("");


  const abrirEntradaManual = (item) => {
    setEntradaManualItem(item);
    setEntradaCantidad(0);
    setEntradaMotivo("");
    setShowEntradaManual(true);
  };

  const guardarEntradaManual = async () => {
    if (guardandoEntrada) return;

    if (entradaCantidad <= 0)
      return toast.warn("La cantidad debe ser mayor a cero.");

    setGuardandoEntrada(true);

    try {

      const notaCompleta = entradaObservacion?.trim()
        ? `${entradaMotivo} - ${entradaObservacion}`
        : entradaMotivo || "Entrada manual";

      const res = await axios.post(
        `${process.env.REACT_APP_API_INVENTARIO}/items/${entradaManualItem._id}/move`,
        {
          kind: "entrada",
          qty: entradaCantidad,
          user: usuarioNombre,
          note: notaCompleta,
        }
      );

      toast.success("Entrada registrada correctamente.");

      setItems((prev) =>
        prev.map((it) =>
          it._id === entradaManualItem._id
            ? { ...it, quantity: it.quantity + entradaCantidad }
            : it
        )
      );

      setEntradaCantidad(0);
      setEntradaMotivo("");
      setEntradaObservacion("");

      setShowEntradaManual(false);

    } catch (err) {
      console.error("❌ Error guardando entrada manual:", err);
      toast.error("No se pudo registrar la entrada manual.");
    } finally {
      setGuardandoEntrada(false);
    }
  };




  const [showMovimientosGlobal, setShowMovimientosGlobal] = useState(false);
  const [movimientosGlobales, setMovimientosGlobales] = useState([]);

  const cargarMovimientosGlobales = async () => {
    try {
      const res = await axios.get(`${API}/movimientos-globales`);
      setMovimientosGlobales(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (showMovimientosGlobal) cargarMovimientosGlobales();
  }, [showMovimientosGlobal]);

  const [movPag, setMovPag] = useState(1);
  const movLimit = 10;
  const movPages = Math.ceil(movimientosGlobales.length / movLimit);

  const movimientosPaginados = movimientosGlobales.slice(
    (movPag - 1) * movLimit,
    movPag * movLimit
  );

  // Paginación movimientos por producto
  const [movProdPage, setMovProdPage] = useState(1);
  const movProdLimit = 5;

  const movProdPages = useMemo(
    () => Math.ceil(movimientos.length / movProdLimit),
    [movimientos]
  );

  const movimientosPorProductoPaginados = useMemo(
    () =>
      movimientos.slice(
        (movProdPage - 1) * movProdLimit,
        movProdPage * movProdLimit
      ),
    [movProdPage, movimientos]
  );

  const cargarWooProducts = async () => {

    try {

      setWooLoading(true);
      setWooResult(null);

      const res = await axios.post(
        `${API}/woo/sync`
      );

      console.log("SYNC RESULT:", res.data);

      setWooResult(
        `Woo sincronizado: ${res.data.created} nuevos productos agregados`
      );

      toast.success(
        `Woo sincronizado: ${res.data.created} nuevos productos agregados`
      );

      // 🔥 Recargar tabla
      load();

    } catch (err) {

      console.error(
        "❌ WOO ERROR:",
        err.response?.data || err.message
      );

      const errorMsg =
        err.response?.data?.error ||
        "Error sincronizando Woo";

      setWooResult(errorMsg);

      toast.error(errorMsg);

    } finally {

      setWooLoading(false);
    }
  };


  return (

    <>

    <PageTitle title="Inventario" />

    <div className="inv-root">

      {/* ===== HEADER ===== */}
      <header className="inv-header">
        <h2 className="inv-title">
          | Inventario
        </h2>
        <div className="inv-actions">
          <button
            className="inv-btn-excel"
            onClick={handleExportExcel}
          >
            <FiDownload size={15} /> Exportar Excel
          </button>
          <button
            className="inv-btn-primary"
            onClick={() => setConfirmWooOpen(true)}
          >
            <FiUpload size={15} /> Importar Woo
          </button>
          <button className="inv-btn-primary" onClick={openCreate}>
            <FiBox size={15} /> Nuevo producto
          </button>
          <button className="inv-btn-primary" onClick={() => setShowMovimientosGlobal(true)}>
            <FiActivity size={15} /> Movimientos
          </button>
        </div>
      </header>

      {/* ===== RESUMEN SUPERIOR ===== */}
      <div className="inv-summary">
        <div className="inv-summary-value">
          <div className="inv-summary-icon">
            <FiDollarSign size={24} />
          </div>
          <div>
            <p className="inv-summary-label">COSTE INVENTARIO</p>
            <h2>${totalCost.toLocaleString("es-CO")}</h2>
            <p className="inv-summary-sale">
              Total venta: ${totalSale.toLocaleString("es-CO")}
            </p>
          </div>
        </div>

        <div className="inv-summary-divider"></div>

        <div className="inv-summary-products">
          <h3>{totalProducts.toLocaleString("es-CO")} productos</h3>

          <div className="inv-summary-bar">
            {categoryStats.map((cat, i) => (
              <div
                key={i}
                className="inv-summary-segment"
                style={{
                  width: `${cat.percent}%`,
                  backgroundColor: cat.color,
                }}
              ></div>
            ))}
          </div>

          <div className="inv-summary-legend">
            {categoryStats.map((cat, i) => (
              <span key={i}>
                <span style={{ color: cat.color }}>●</span>{" "}
                <span style={{ color: "#555" }}>
                  {cat.name}: {cat.count.toLocaleString("es-CO")}
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* ===== FILTROS ===== */}
      <div className="inv-filters">
        <div className="inv-row">
          <div className="invt-field">
            <FiSearch className="inv-icon" />
            <input
              placeholder="Buscar por código, nombre, proveedor…"
              value={filters.search}
              onChange={(e) =>
                setFilters({ ...filters, search: e.target.value })
              }
            />
          </div>

          <select
            value={filters.category}
            onChange={(e) =>
              setFilters({ ...filters, category: e.target.value })
            }
          >
            <option value="">Todas las categorías</option>
            {uniqueCategories.map((cat) => (
              <option key={cat}>{cat}</option>
            ))}
          </select>

          <select
            value={filters.type}
            onChange={(e) => setFilters({ ...filters, type: e.target.value })}
          >
            <option value="">Todos los tipos</option>
            {uniqueTypes.map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>

          <select
            value={filters.proveedor || ""}
            onChange={(e) =>
              setFilters({ ...filters, proveedor: e.target.value })
            }
          >
            <option value="">Todos los proveedores</option>
            {uniqueProviders.map((p) => (
              <option key={p}>{p}</option>
            ))}
          </select>

          <select
            value={filters.location}
            onChange={(e) =>
              setFilters({ ...filters, location: e.target.value })
            }
          >
            <option value="">Todas las bodegas</option>
            {uniqueLocations.map((loc) => (
              <option key={loc}>{loc}</option>
            ))}
          </select>

          <select
            value={filters.shelf}
            onChange={(e) => setFilters({ ...filters, shelf: e.target.value })}
          >
            <option value="">Todas las estanterías</option>
            {uniqueShelves.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
          <button
            className="inv-btn-ghost"
            onClick={() => {
              setFilters({
                search: "",
                category: "",
                type: "",
                location: "",
                shelf: "",
                proveedor: "",
              });
              setPage(1);
            }}
          >
            Restablecer
          </button>
        </div>
      </div>

      {/* ===== TABLA ===== */}
      <div className="inv-table">
        <table>
          <thead>
            <tr>
              <th>SKU</th>
              <th>Producto</th>
              <th>Categoría</th>
              <th>Tipo</th>
              <th>Proveedor</th>
              <th>Ingreso</th>
              <th>Bodega</th>
              <th>Estantería</th>
              <th>Cant. Actual</th>
              <th>Precio Coste</th>
              <th>Precio Venta</th>
              <th>Rotación 30d</th>
              <th>Observaciones</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {filteredItems.map((it) => (
              <tr key={it._id}>
                <td>{it.code}</td>
                <td>{it.name}</td>
                <td>{it.category}</td>
                <td>{it.type}</td>
                <td>{it.proveedor}</td>
                <td>
                  {it.fechaIngreso
                    ? new Date(it.fechaIngreso).toLocaleDateString()
                    : ""}
                </td>
                <td>{it.location}</td>
                <td>{it.shelf}</td>
                <td>{it.quantity?.toLocaleString("es-CO")}</td>
                <td>${it.costPrice?.toLocaleString("es-CO")}</td>
                <td>${it.salePrice?.toLocaleString("es-CO")}</td>
                <td>
                  {it.rotacion30d?.toLocaleString("es-CO") || 0}
                </td>
                <td className="inv-ellipsis" title={it.observaciones || ""}>
                  {it.observaciones}
                </td>
                <td className="inv-actions-row">
                  <button
                    className="inv-icon-btn"
                    title="Ver movimientos"
                    onClick={() => verMovimientos(it)}
                  >
                    <FiActivity />
                  </button>
                  <button
                    className="inv-icon-btn"
                    title="Editar"
                    onClick={() => openEdit(it)}
                  >
                    <FiEdit2 />
                  </button>
                  <button
                    className="inv-icon-btn"
                    onClick={() => abrirEntradaManual(it)}  // 👈 NUEVA FUNCIÓN
                    title="Agregar entrada manual"
                  >
                    <FiPlusCircle />
                  </button>
                  <button
                    className="inv-icon-btn inv-danger"
                    title="Eliminar"
                    onClick={() => delItem(it._id)}
                  >
                    <FiTrash2 />
                  </button>
                </td>
              </tr>
            ))}

            {items.length === 0 && (
              <tr>
                <td colSpan="13" className="inv-empty">
                  Sin resultados
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* 🔹 PAGINACIÓN */}
        <div className="inv-paginacion">
          <button
            className="inv-btn-paginacion"
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            disabled={page === 1}
          >
            Anterior
          </button>

          <span className="inv-pagina-info">
            Página {page} de {pages}
          </span>

          <button
            className="inv-btn-paginacion"
            onClick={() => setPage((p) => Math.min(p + 1, pages))}
            disabled={page === pages}
          >
            Siguiente
          </button>
        </div>
      </div>

      {/* ===== MODAL CREAR / EDITAR ===== */}
      {showForm && (
        <div className="inv-modal-overlay" onClick={() => setShowForm(false)}>
          <div className="inv-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{editing ? "Modificación de Producto" : "Creación de Producto"}</h3>
            <form
              id="inventario-form"
              onSubmit={saveItem}
              className="inv-form-grid"
            >
              <label className="inv-form-label">
                SKU
                <input
                  className="inv-form-input"
                  value={form.code}
                  disabled={editing}
                  onChange={(e) => setForm({ ...form, code: e.target.value })}
                  required
                />
              </label>
              <label className="inv-form-label">
                Nombre
                <input
                  className="inv-form-input"
                  value={form.name}
                  disabled={editing}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
              </label>
              <label className="inv-form-label">
                Categoría
                <input
                  className="inv-form-input"
                  value={form.category}
                  onChange={(e) =>
                    setForm({ ...form, category: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Tipo
                <select
                  className="inv-form-select"
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                >
                  <option>Digital</option>
                  <option>Fisico</option>
                  <option>Servicio</option>
                </select>
              </label>
              <label className="inv-form-label">
                Proveedor
                <input
                  className="inv-form-input"
                  value={form.supplier}
                  onChange={(e) =>
                    setForm({ ...form, supplier: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Bodega
                <input
                  className="inv-form-input"
                  value={form.warehouse}
                  onChange={(e) =>
                    setForm({ ...form, warehouse: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Estantería
                <input
                  className="inv-form-input"
                  value={form.shelf}
                  onChange={(e) => setForm({ ...form, shelf: e.target.value })}
                />
              </label>
              <label className="inv-form-label">
                Cant. Inicial
                <input
                  type="number"
                  className="inv-form-input"
                  min="0"
                  value={form.initialQty}
                  disabled={editing}
                  onChange={(e) =>
                    setForm({ ...form, initialQty: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Cant. Actual
                <input
                  type="number"
                  className="inv-form-input"
                  min="0"
                  value={form.currentQty}
                  disabled={editing}
                  onChange={(e) =>
                    setForm({ ...form, currentQty: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Precio Coste
                <input
                  type="number"
                  className="inv-form-input"
                  min="0"
                  value={form.costPrice}
                  onChange={(e) =>
                    setForm({ ...form, costPrice: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Precio Venta
                <input
                  type="number"
                  className="inv-form-input"
                  min="0"
                  value={form.salePrice}
                  onChange={(e) =>
                    setForm({ ...form, salePrice: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label">
                Ingreso
                <input
                  type="date"
                  className="inv-form-input"
                  value={form.receivedAt}
                  disabled={editing}
                  onChange={(e) =>
                    setForm({ ...form, receivedAt: e.target.value })
                  }
                />
              </label>
              <label className="inv-form-label inv-form-col2">
                Observaciones
                <textarea
                  rows="3"
                  className="inv-form-textarea"
                  value={form.notes}
                  onChange={(e) =>
                    setForm({ ...form, notes: e.target.value })
                  }
                />
              </label>
            </form>

            <div className="inv-modal-actions">
              <button
                type="button"
                className="desp-btn-secondary"
                onClick={() => setShowForm(false)}
              > 
                Cancelar
              </button>
              <button
                type="submit"
                form="inventario-form"
                className="inv-btn-primary"
                disabled={saving}
              >
                {saving ? "Guardando..." : editing ? "Modificar producto" : "Crear producto"}
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmWooOpen && (
        <div
          className="inv-modal-overlay"
          onClick={() => {

            if (wooLoading) return;

            setConfirmWooOpen(false);
            setWooResult(null);
          }}
        >
          <div
            className="inv-confirm-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <h3>¿Sincronizar con Woo?</h3>

            <p>
              Esto creará nuevos productos desde WooCommerce.
            </p>

            {wooLoading && (
              <p style={{ marginTop: 12 }}>
                Importando productos...
              </p>
            )}

            {wooResult && (
              <div
                style={{
                  marginTop: 14,
                  padding: 12,
                  borderRadius: 10,
                  background: "#f4f4f4",
                  fontSize: ".92rem",
                }}
              >
                {wooResult}
              </div>
            )}

            <div className="inv-modal-actions">

              <button
                className="inv-btn-secondary"
                disabled={wooLoading}
                onClick={() => {

                  setConfirmWooOpen(false);
                  setWooResult(null);
                }}
              >
                Cerrar
              </button>

              <button
                className="inv-btn-primary"
                disabled={wooLoading}
                onClick={cargarWooProducts}
              >
                {wooLoading
                  ? "Importando..."
                  : "Confirmar"}
              </button>

            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL MOVIMIENTOS ===== */}
      {showMovements && (
        <div
          className="inv-modal-overlay"
          onClick={() => setShowMovements(false)}
        >
          <div
            className="inv-modal small"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Historial de movimientos — {activeItem?.name}</h3>
            <p>
              📊 Aquí se mostrará el historial de ingresos y salidas (conectado
              al módulo de despachos).
            </p>
            <div className="inv-modal-actions">
              <button
                className="inv-btn-secondary"
                onClick={() => setShowMovements(false)}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL CONFIRMACIÓN ELIMINAR ===== */}
      {confirmOpen && (
        <div className="inv-modal-overlay" onClick={() => setConfirmOpen(false)}>
          <div className="inv-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <h3>¿Deseas eliminar este producto?</h3>
            <p>Esta acción no se puede deshacer.</p>
            <div className="inv-modal-actions">
              <button className="inv-btn-secondary" onClick={() => setConfirmOpen(false)}>
                Cancelar
              </button>
              <button className="inv-btn-danger" onClick={confirmDelete}>
                Eliminar
              </button>
            </div>
          </div>
        </div>
      )}

      {showMovModal && (
        <div
          className="desp-modal-overlay"   // puedes usar mismo estilo overlay de otros modales
          onClick={() => setShowMovModal(false)}
        >
          <div
            className="desp-modal"         // o crea una clase específica tipo inv-modal
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "800px" }}
          >
            {/* CABECERA */}
            <div className="desp-modal-header">
              <h3>Movimientos de Inventario por Producto</h3>
              {movItem && (
                <p style={{ fontSize: "0.85rem", color: "#666", marginTop: 4 }}>
                  <strong>{movItem.code}</strong> — {movItem.name}
                </p>
              )}
            </div>

            {/* CUERPO */}
            <div className="desp-modal-content">
              {movimientos.length > 0 ? (
                <table className="detalle-tabla">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Tipo</th>
                      <th>Cantidad</th>
                      <th>Antes</th>
                      <th>Después</th>
                      <th>Usuario</th>
                      <th>Detalle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {movimientosPorProductoPaginados.map((m) => (
                      <tr key={m._id}>
                        <td>
                          {m.createdAt
                            ? new Date(m.createdAt).toLocaleString("es-CO")
                            : "—"}
                        </td>
                        <td>{getTipoMovimientoLabel(m)}</td>
                        <td style={{ textAlign: "right" }}>
                          {m.qty ? m.qty.toLocaleString("es-CO") : "—"}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {m.beforeQty != null
                            ? m.beforeQty.toLocaleString("es-CO")
                            : "—"}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {m.afterQty != null
                            ? m.afterQty.toLocaleString("es-CO")
                            : "—"}
                        </td>
                        <td>{m.user || "Sistema"}</td>
                        <td style={{ maxWidth: 260 }}>
                          {m.detalleCambio || m.note || "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ textAlign: "center", color: "#777" }}>
                  Este producto aún no tiene movimientos registrados.
                </p>
              )}
            </div>

            {/* PAGINACIÓN — Movimientos por producto */}
            {movimientos.length > 5 && (
              <div className="mov-pagination">
                <button
                  disabled={movProdPage === 1}
                  onClick={() => setMovProdPage((p) => p - 1)}
                >
                  Anterior
                </button>

                <span>Página {movProdPage} de {movProdPages}</span>

                <button
                  disabled={movProdPage === movProdPages}
                  onClick={() => setMovProdPage((p) => p + 1)}
                >
                  Siguiente
                </button>
              </div>
            )}


            {/* ACCIONES */}
            <div className="desp-modal-actions">
              <button
                className="desp-btn-secondary"
                onClick={() => setShowMovModal(false)}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {showEntradaManual && (
        <div className="desp-modal-overlay" onClick={() => setShowEntradaManual(false)}>
          <div className="inv-mini-modal modal-animate" onClick={(e) => e.stopPropagation()}>

            {/* HEADER */}
            <div className="inv-mini-header">
              <h3>Registrar Entrada</h3>
              <small>
                {entradaManualItem.code} — {entradaManualItem.name}
              </small>
            </div>

            {/* BODY */}
            <div className="inv-mini-body">

              <div className="inv-mini-group">
                <label>Stock actual</label>
                <input
                  type="text"
                  value={entradaManualItem.quantity}
                  disabled
                />
              </div>

              <div className="inv-mini-group">
                <label>Cantidad a ingresar</label>
                <input
                  type="number"
                  min="1"
                  value={entradaCantidad}
                  onChange={(e) => setEntradaCantidad(Number(e.target.value))}
                />
              </div>

              <div className="inv-mini-group">
                <label>Nuevo total</label>
                <input
                  type="text"
                  value={
                    (entradaManualItem.quantity || 0) + (entradaCantidad || 0)
                  }
                  disabled
                />
              </div>

              <div className="inv-mini-group">
                <label>Motivo</label>
                <select
                  value={entradaMotivo}
                  onChange={(e) => setEntradaMotivo(e.target.value)}
                >
                  <option value="">Seleccionar motivo</option>
                  <option value="Ajuste de inventario">Ajuste de inventario</option>
                  <option value="Compra">Compra</option>
                  <option value="Devolución">Devolución</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>

              <div className="inv-mini-group">
                <label>Observación</label>
                <textarea
                  rows="2"
                  value={entradaObservacion}
                  onChange={(e) => setEntradaObservacion(e.target.value)}
                />
              </div>

            </div>

            {/* ACTIONS */}
            <div className="desp-modal-actions">
              <button
                className="desp-btn-secondary"
                onClick={() => setShowEntradaManual(false)}
              >
                Cancelar
              </button>

              <button
                className="desp-btn-primary"
                onClick={guardarEntradaManual}
                disabled={
                  guardandoEntrada ||
                  !entradaCantidad ||
                  entradaCantidad <= 0 ||
                  !entradaMotivo
                }
              >
                {guardandoEntrada ? "Guardando..." : "Registrar entrada"}
              </button>
            </div>

          </div>
        </div>
      )}


      {showMovimientosGlobal && (
        <div className="inv-modal-overlay" onClick={() => setShowMovimientosGlobal(false)}>

          <div className="mov-modal" onClick={(e) => e.stopPropagation()}>

            <div className="mov-header">
              <h3 className="mov-title">Movimientos del Inventario</h3>

              <button
                className="desp-btn-secondary mov-export-btn"
                onClick={async () => {
                  try {
                    const res = await axios.get(`${API}/movimientos/export.xlsx`, {
                      responseType: "blob",
                    });

                    const blob = new Blob([res.data]);
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `movimientos_${new Date().toISOString().slice(0, 10)}.xlsx`;
                    a.click();
                  } catch (err) {
                    console.error(err);
                    toast.error("Error exportando movimientos");
                  }
                }}
              >
                <FiDownload size={14} /> Exportar Excel
              </button>
            </div>

            <div className="mov-table-container">
              <table className="mov-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Usuario</th>
                    <th>SKU</th>
                    <th>Producto</th>
                    <th>Tipo</th>
                    <th>Detalle</th>
                    <th>Cantidad</th>
                    <th>Valor Unitario</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {movimientosPaginados.map((m, i) => (
                    <tr key={i}>
                      <td>{new Date(m.fecha).toLocaleString("es-CO")}</td>
                      <td style={{ textAlign: "left" }}>
                        {m.user || "—"}
                      </td>
                      <td>{m.codigo}</td>
                      <td>{m.nombreProducto}</td>
                      <td>{m.tipo}</td>
                      <td>{m.detalle}</td>
                      <td style={{ textAlign: "right" }}>
                        {m.cantidad?.toLocaleString("es-CO")}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {m.valorUnitario
                          ? `$${m.valorUnitario.toLocaleString("es-CO")}`
                          : "—"}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {m.total != null
                          ? `$${m.total.toLocaleString("es-CO")}`
                          : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Paginación */}
            <div className="mov-pagination">
              <button
                disabled={movPag === 1}
                onClick={() => setMovPag((p) => p - 1)}
              >
                Anterior
              </button>

              <span>Página {movPag} de {movPages}</span>

              <button
                disabled={movPag === movPages}
                onClick={() => setMovPag((p) => p + 1)}
              >
                Siguiente
              </button>
            </div>

            {/* Botón cerrar */}
            <div className="mov-actions">
              <button onClick={() => setShowMovimientosGlobal(false)}>
                Cerrar
              </button>
            </div>

          </div>
        </div>
      )}

    </div>

    </>

  );
}

export default Inventario;
